<div class="app-view-container h-full">
  <div class="main-actions">
    <div class="actions-container">
      <div class="actions-group actions-left">
        <sp-navigation-link *ngIf="navLinks.length > 1" [navLinks]="navLinks" (selectedTab)="currentTabClick($event)"></sp-navigation-link>
      </div>
      <!-- Search filter -->
      <div class="actions-group actions-right grow">
        <sp-search-field
          class="action"
          [searchText]="searchText"
          (keyUpInput)="searchTextChanged($event)"
          (clearInput)="clearSearch($event)"
          [placeholder]="searchPlaceholder"
          (toggleMobileSearch)="toggleMobileSearch()"
          (addOnEnter)="addOnEnter()"
          [mobileSearch]="screenSizeDetectorService.isSmallScreen"
        ></sp-search-field>

        @if (screenSizeDetectorService.isLargeScreen) {
          <div class="action-item ml-2">
            <button mat-icon-button [matMenuTriggerFor]="gridMenu">
              <mat-icon class="material-icons-outlined" matTooltip="Table setting">settings</mat-icon>
            </button>
            <mat-menu #gridMenu="matMenu">
              <ng-template matMenuContent>
                <sp-table-wheel-setting
                  (changeView)="changeView($event)"
                  [headerType]="assetViewTypeService.getViewType(gridSettingsKeySuffix) === 'list' ? 'collectionList' : 'collectionGallery'"
                  [menuObjects]="assetViewTypeService.getViewType(gridSettingsKeySuffix) === 'list' ? collectionsTableMenuObject : collectionsGalleryMenuObject"
                  [selectedViewType]="assetViewTypeService.getViewType(gridSettingsKeySuffix)"
                  [selectedViewSection2]="selectedViewSection2"
                  (sortBy)="sortBy($event)"
                  [sortByNew]="sortByNew"
                  [defaultTableCols]="tableData?.columns"
                  [additionalColumns]="tableData?.additionalColumns"
                ></sp-table-wheel-setting>
              </ng-template>
            </mat-menu>
          </div>
        }
      </div>
    </div>

    @if (screenSizeDetectorService.isLargeScreen) {
      <div class="mobile-search" [ngClass]="{ 'is-open': isMobileSearchOpen }" (window:resize)="onEvent($event)" (focusout)="onEvent($event)">
        <sp-search-field
          [searchText]="searchText"
          [maxWidth]="''"
          (keyUpInput)="searchTextChanged($event)"
          (clearInput)="clearSearch($event)"
          [placeholder]="searchPlaceholder"
          [mobileSearch]="true"
        ></sp-search-field>
      </div>
    }
  </div>
  <div class="app-content-container">
    <router-outlet></router-outlet>
  </div>
</div>
